import React from "react";
import style from "./css/Navbar.module.css";
import { Link } from "react-router-dom";
import logo from './assests/logo.png'

function Navbar() {
  return (
    <>
      <div className={`container-fluid bg-primary ${style.s_container}`}>
        <div className="container d-flex justify-content-end">
          <div className={style.left}>
            <Link to="tel:+919128414128"> 9128414128</Link>
          </div>
          <div className={style.right}>
            <Link
              to="https://www.facebook.com/skycomputereducationdbg/"
              target="blank"
            >
              <i className={`fa-brands fa-facebook ${style.s_icon}`}></i>
            </Link>
            <Link
              to="https://www.instagram.com/skycomputereducation/"
              target="black"
            >
              <i className={`fa-brands fa-instagram ${style.s_icon}`}></i>
            </Link>
            <Link
              to="https://www.youtube.com/c/SKYCOMPUTEREDUCATION"
              target="black"
            >
              <i className={`fa-brands fa-youtube ${style.s_icon}`}></i>
            </Link>
          </div>
        </div>
      </div>
      <nav
        className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top"
        id={style.menu}
      >
        <div className="container-fluid">
          <Link className="nav-link navbar-brand" to="/">
            <div className={style.logo}>
              <img src={logo} alt="sky logo" />
              <h1>SKY COMPUTER EDUCATION</h1>
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon" id={style.icon}></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link " to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link " to="/ourcourse">
                  Our Courses
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link " to="/ourteam">
                  Our Team
                </Link>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Student Zone
                </Link>
                <ul className="dropdown-menu dropdown-menu-dark">
                  <li>
                    <Link className="dropdown-item" to="https://skycomputereducation.com/test/" target="_blank">
                      Online Test
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="https://skycomputereducation.com/result/" target="_blank">
                      View Result
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="https://skycomputereducation.com/verify/" target="_blank">
                      Verify Certificate
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link " to="/contactus">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
